export function toLondonTime(date: Date | null) {
  if (!date) return null;
  const year = date.getFullYear();

  // Last Sunday in March
  const march = new Date(year, 2, 31);
  march.setDate(31 - march.getDay());

  // Last Sunday in October
  const october = new Date(year, 9, 31);
  october.setDate(31 - october.getDay());

  if (date >= march && date < october) {
    date.setTime(date.getTime() - 60 * 60 * 1000);
  }
  return date;
}
